/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import DefaultProximityLogo from '../../components/1elements/Icons/svg/proximityLogo.svg'
import sixfactorLogo from '../../components/1elements/Icons/svg/sixfactorLogoMono.svg'
import { Text } from '../../components/1elements'
import signInBackground from '../../assets/signInBackground.jpg'
import {
  getSignInLogo,
  getSignInText,
  getSigninBg
} from '../../common/dynamicCustomizationService'
import './AuthenticationLayout.scss'

const proximityLogo = getSignInLogo() ?? DefaultProximityLogo
const welcomeText = getSignInText() ?? 'Mapping Business Intelligence'
const signinBg = getSigninBg()

let styledBgImg = ''

if (!signinBg) styledBgImg = signInBackground

const GuestInitiated = () => {
  return (
    <div
      className='authentication-root'
      style={{ backgroundImage: `url(${styledBgImg})` }}
    >
      <div className='authentication-login-container'>
        <div className='authentication-logo'>
          <img src={proximityLogo} alt='logo' />
          <div
            id='localCheat'
            type='oneLiner'
            className='authentication-tagline'
            dangerouslySetInnerHTML={{ __html: welcomeText }}
          />
        </div>

        <Text>
          <p>Check your inbox for an email. If it does not appear, <strong>
            check your spam folder.</strong></p>
        </Text>

        <Text>
          <p>The email will contain a link which is valid for only a short
          period of time. The link will log you into the system and
          cannot be reused.</p>
        </Text>

        <Text>
          <p><strong>DO NOT SHARE THIS LINK WITH ANYONE.</strong></p>
        </Text>

        <div className='authentication-footer'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://sixfactor.com/'
          >
            <img
              src={sixfactorLogo}
              alt='sixfactor'
              width='60px'
              className='authentication-sixfactor-logo'
            />
          </a>
          <Text type='terms'>
            <a
              className='authentication-link'
              target='_blank'
              rel='noopener noreferrer'
              href='https://sixfactor.com/contact/'
            >
              Customer Support
            </a>
          </Text>
        </div>
      </div>
    </div>
  )
}

export default GuestInitiated
